/**
 * デバイスの種類を判定するユーティリティクラス
 * - PC / モバイルの判定
 * - デバウンス関数の提供
 */
export class DeviceChecker {
    /**
     * インスタンス作成
     * @param {number} [breakPoint=767] - PCとモバイルの境界となる幅(px)
     */
    constructor(breakPoint = 767) {
        this.breakPoint = breakPoint;
    }

    /**
     * PCかどうかを判定
     * @returns {boolean} PCの場合はtrue
     * @private
     */
    _isPc() {
        return window.matchMedia(`(min-width: ${this.breakPoint}px)`).matches;
    }

    /**
     * モバイルかどうかを判定
     * @returns {boolean} モバイルの場合はtrue
     * @private
     */
    _isMobile() {
        return !this._isPc();
    }

    /**
     * デバウンス関数
     * - 関数の連続呼び出しを遅延させ、最後の1回だけ実行
     * @param {Function} func - デバウンスする関数
     * @param {number} [wait=200] - 遅延時間（ms）
     * @returns {Function} デバウンス済み関数
     * @private
     */
    _debounce(func, wait = 200) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }
}
